var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_79de9198"]},_vm.$listeners),[_c('cube-button',{attrs:{"primary":"","open-type":"share","tip":"需在小程序环境下预览"}},[_vm._v("分享")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }